enum Module {
  // Moudules name
  name = "hosterModules",
  desc = "hosterModules/",
}

enum Mutations {
  // Mutations types
  SetInVitMember = "setInvitMember",
  RemoveInviteMember = "removeInvitMember",
  SetInviteDate = "setInvitDate",
  RemoveInviteDate = "removeInvitDate",
  SetInviteDateTime = "setInvitDateTime",
  RemoveInviteDateTime = "removeInvitDateTime",
  InitHosterData = "initHosterData",
  SetHosterData = "setHosterData",
  SetEventResponse = "setEventResponse",
  SetInvitePerson = "setInvitePerson",
  SetInviteScheduler = "setInviteScheduler",
  SetLocation = "setLocation",
  SetKeyWordPersonList = "setKeyWordPersonList",
  SetIntervalMinutes = "setIntervalMinutes",
  SetEventSchedularWithCount = "setEventSchedularWithCount",
  SetResolution = "setResolution",
}

enum Actions {
  // action types
  HandInivteMember = "handInvitMember",
  HandInivteMemberRemove = "handInvitMemberRemove",
  HandInviteDate = "handInvitDate",
  HandInviteDateTime = "handInvitDateTime",
  //HandHeaderCounter = 'handHeaderCounter',
  HandHosterAllData = "handHosterAllData",
  LoadEventResponse = "loadEventResponse",
  LoadInvitePerson = "loadInvitePerson",
  LoadInviteScheduler = "loadInviteScheduler",
  LoadEventSchedularWithCount = "loadEventSchedularWithCount",
  LoadLocation = "loadLocation",
  SubmitHosterDate = "submitHosterData",
  SearchPerson = "searchPerson",
  UpdateHosterDate = "updateHosterData",
  HandIntervalMinutes = "handIntervalMinutes",
  UpdateResolution = "updateResolution",
  ResetResolution = "resetResolution",
  SubmitResolution = "submitResolution",
}

enum Getters {
  // getters types
  IntervalMinutes = "intervalMinutes",
  InvitMember = "invitMember",
  InviteDate = "inviteDate",
  InviteDateList = "inviteDateList",
  InviteInfo = "inviteInfo",
  EventResponse = "eventResponse",
  EventSchedularWithCount = "eventSchedularWithCount",
  InvitePerson = "invitePerson",
  InviteScheduler = "inviteScheduler",
  Location = "location",
  KeywordPersonList = "keywordPersonList",
  InviteDateMessage = "inviteDateMessage",
  TimelineRowGroupHeaderList = "timelineRowGroupHeaderList",
  TimelineRowHeaderList = "timelineRowHeaderList",
  TimelineDataList = "timelineDataList",
  Resolution = "resolution",
}

export { Module, Actions, Mutations, Getters };
